import React from 'react';
import { MotionConfig } from 'framer-motion';
import { LanguageProvider } from './contexts/LanguageContext';
import { Nav } from './components/Nav';
import { Hero } from './components/sections/Hero';
import { Clarity } from './components/sections/Clarity';
import { SystemSection } from './components/sections/SystemSection';
import { Insights } from './components/sections/Insights';
import { Team } from './components/sections/Team';
import { Structure } from './components/sections/Structure';
import { MoreServices } from './components/sections/MoreServices';
import { Process } from './components/sections/Process';
import { Closing } from './components/sections/Closing';
import { Footer } from './components/sections/Footer';
type AppProps = {
  initialLanguage?: 'es' | 'en';
};
export function App({
  initialLanguage = 'es'
}: AppProps) {
  return <LanguageProvider initialLang={initialLanguage} data-id="element-0" data-mp="28sl511qepuh3">
      <MotionConfig reducedMotion="user" data-id="element-1" data-mp="23w4fq47h1a2f">
        <div className="min-h-screen w-full bg-ink font-sans" data-id="element-2" data-mp="23v2sz2h3ez4v">
          <Nav data-id="element-3" data-mp="3ikqwhsrnks2k" />
          <main data-id="element-4" data-mp="3ij65gd4jrr9g">
            <Hero data-id="element-5" data-mp="3ijpe138b53at" />
            <Clarity data-id="element-6" data-mp="3ii4qhxkeukmg" />
            <SystemSection data-id="element-7" data-mp="3ml14faz09sk2" />
            <Insights data-id="element-8" data-mp="3mk8710lxsfel" />
            <Team data-id="element-9" data-mp="3mjq3rk0ux0x6" />
            <Structure data-id="element-10" data-mp="3mj6jhwnqi0fz" />
            <MoreServices data-id="element-11" data-mp="3rbrakqf99zft" />
            <Process data-id="element-12" data-mp="3rdkisa5iorpx" />
            <Closing data-id="element-13" data-mp="3rd191gq0t9mz" />
          </main>
          <Footer data-id="element-14" data-mp="5orv1p50w72" />
        </div>
      </MotionConfig>
    </LanguageProvider>;
}